import { useState } from 'react';
import api from 'services/api';
import IAAnalysisPanel from 'components/shared/IAAnalysisPanel';

export default function ExportFECPage() {
  const [annee, setAnnee] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const r = await api.get(`/syscohada/export-fec?annee=${annee}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `FEC_GSS_${annee}.txt`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch {} finally { setLoading(false); }
  };

  return (
    <div>
      <div className="stats-grid stats-grid--3">
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">Format</span></div>
          <div className="stat-card-value" style={{ fontSize: 16 }}>FEC (Art. L47 A-I)</div>
          <div className="stat-card-sub">Fichier Écritures Comptables</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">Norme</span></div>
          <div className="stat-card-value" style={{ fontSize: 16 }}>SYSCOHADA</div>
          <div className="stat-card-sub">Conforme OHADA</div>
        </div>
        <div className="stat-card">
          <div className="stat-card-header"><span className="stat-card-label">Compatible</span></div>
          <div className="stat-card-value" style={{ fontSize: 16 }}>Sage / Ciel</div>
          <div className="stat-card-sub">Import direct</div>
        </div>
      </div>

      <div className="content-card">
        <div className="content-card-title">Export FEC — Fichier Écritures Comptables</div>
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <p style={{ color: '#555', marginBottom: 24, maxWidth: 600, margin: '0 auto 24px' }}>
            Le FEC (Fichier des Écritures Comptables) est le format standard pour transmettre vos écritures à votre expert-comptable ou à l'OTR (Office Togolais des Recettes).
            Ce fichier contient toutes les écritures validées de l'exercice sélectionné au format tabulé.
          </p>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 24 }}>
            <label style={{ fontWeight: 600 }}>Exercice :</label>
            <input type="number" className="gss-input" value={annee} onChange={e => setAnnee(Number(e.target.value))} style={{ width: 120, textAlign: 'center' }} />
          </div>

          <button className="gss-btn gss-btn-primary" onClick={handleExport} disabled={loading} style={{ padding: '12px 32px', fontSize: 14 }}>
            {loading ? 'Génération en cours...' : 'Télécharger le FEC'}
          </button>

          <div style={{ marginTop: 32, padding: 16, background: '#f9f9f9', borderRadius: 8, fontSize: 12, color: '#888', maxWidth: 500, margin: '32px auto 0' }}>
            <strong>Colonnes du FEC :</strong><br />
            JournalCode | JournalLib | EcritureNum | EcritureDate | CompteNum | CompteLib | CompAuxNum | CompAuxLib | PieceRef | PieceDate | EcritureLib | Debit | Credit | EcritureLet | DateLet | ValidDate | Montantdevise | Idevise
          </div>

          <div style={{ marginTop: 24, maxWidth: 500, margin: '24px auto 0' }}>
            <IAAnalysisPanel
              type="fec"
              data={{ exercice: annee }}
              buttonLabel="Audit IA avant export"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
